import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default__default, { useState, useEffect } from 'react';
import PropTypes__default from 'prop-types';
import styles from '../../../../node_modules/@flixbus/honeycomb/dist/scss/components/data-table.scss.js';
import { CellContent, SelectionInputProps } from '../../data-table-prop-types.js';
import HoneyBem from '../../../../packages/honey-bem/honey-bem.js';
import Checkbox from '../../../checkbox/checkbox.js';
import { Injecss } from '../../../../packages/injecss/injecss.js';

const _excluded = ["extraClasses", "cells", "selectionInputProps", "isSelected"];
const dataTableBem = HoneyBem.init('data-table', styles);
const DataTableRow = _ref => {
  let {
      extraClasses,
      cells,
      selectionInputProps,
      isSelected
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const [selected, setSelected] = useState(isSelected);
  useEffect(() => {
    setSelected(isSelected);
  }, [isSelected]);

  /**
   * calls back selectionInputProps.onChange with current input status and updates component state
   * @param {InputEvent} event - event object
   */
  const handleChange = event => {
    if (selectionInputProps.onChange) {
      selectionInputProps.onChange({
        value: selectionInputProps.value,
        selected: event.target.checked
      });
    }
    setSelected(event.target.checked);
  };
  return /*#__PURE__*/React__default__default.createElement("tr", _extends({
    className: dataTableBem.e('row', {
      selected
    }, extraClasses)
  }, selected && {
    'aria-selected': 'true'
  }, rest), selectionInputProps && /*#__PURE__*/React__default__default.createElement("td", null, /*#__PURE__*/React__default__default.createElement(Checkbox, _extends({}, selectionInputProps, {
    checked: selected,
    onChange: handleChange,
    small: true
  }))), cells.map((cell, index) => index === 0 ? /*#__PURE__*/React__default__default.createElement("th", {
    scope: "row",
    key: index
  }, cell) : /*#__PURE__*/React__default__default.createElement("td", {
    key: index
  }, cell)));
};
DataTableRow.displayName = 'DataTableRow';
DataTableRow.defaultProps = {
  extraClasses: null,
  selectionInputProps: null,
  isSelected: false
};
DataTableRow.propTypes = {
  /** Injection in className */
  extraClasses: PropTypes__default.string,
  /** List of row cells: [`string`|`node`|`number`] */
  cells: CellContent.isRequired,
  /** Enables selectable row by providing the required input props */
  selectionInputProps: SelectionInputProps,
  /** Sets row's selected state */
  isSelected: PropTypes__default.bool
};
var DataTableRow$1 = Injecss(DataTableRow, styles);

export { DataTableRow$1 as default };
